import * as actions from "appRedux/actions/roomPlan/roomplanEventActionType"
import { DateApi } from 'types'

export interface EventParams {
    start_date: DateApi
    end_date: DateApi
    roomNumberSearch?: string
}

export interface roomplanEventType {
    loader: boolean,
    dataSource: Array<any>,
    dataSourceSignature?: string | null,
    process: any
}

const initialState: roomplanEventType = {
    loader: false,
    dataSource: [],
    process: { status: false, action: "", message: "" }
}

const getCollectionSignature = (payload: any): string | null => {
    try {
        return JSON.stringify(Array.isArray(payload) ? payload : [])
    } catch {
        return null
    }
}

export default (state: roomplanEventType = initialState, action: actions.RoomPlanEventAction): roomplanEventType => {
    switch (action.type) {
        case actions.ROOMPLAN_EVENT_REQUEST: {
            return {
                ...state,
                loader: true
            }
        }
        case actions.ROOMPLAN_EVENT_DATASOURCE_SUCCESS: {
            if (state.dataSource === action.payload) {
                return state.loader ? { ...state, loader: false } : state
            }

            const nextSignature = getCollectionSignature(action.payload)
            if (nextSignature !== null && state.dataSourceSignature === nextSignature) {
                return state.loader ? { ...state, loader: false } : state
            }

            return {
                ...state,
                loader: false,
                dataSource: action.payload,
                dataSourceSignature: nextSignature
            }
        }
        case actions.ROOMPLAN_EVENT_PROCESS_SUCCESS: {
            // The request catch-path dispatches PROCESS_SUCCESS without a following
            // DATASOURCE_SUCCESS, so the loader would stay true forever. Reset it
            // here. Drag/drop mutation sagas also fire PROCESS_SUCCESS, where the
            // loader is already false, so this is a no-op for them.
            return {
                ...state,
                loader: false,
                process: action.payload
            }
        }
        case actions.ROOMPLAN_EVENT_PROCESS_RESET: {
            return {
                ...state,
                process: { status: false, action: "", message: "" }
            }
        }
        default:
            return state
    }
}
